import { defineStore } from "pinia";

export const usePermissionsStore = defineStore("permissions", {
  state: () => ({
    permissions: {
      superadmin: {
        flows: {
          read: true,
          duplicate: true,
        },
        integrations: {
          read: true,
          write: true,
        },
        reports: {
          read: true,
        },
        users: {
          read: true,
        },
        customizations: {
          read: true,
        },
        qatools: {
          read: true,
        },
      },
      system_admin: {
        flows: {
          read: true,
          duplicate: true,
        },
        integrations: {
          read: true,
          write: true,
        },
        reports: {
          read: true,
        },
        users: {
          read: true,
        },
        customizations: {
          read: true,
        },
        organizations: {
          read: true,
        },
        qatools: {
          read: true,
        },
      },
      admin: {
        flows: {
          read: true,
          duplicate: true,
        },
        integrations: {
          read: true,
          write: true,
        },
        reports: {
          read: true,
        },
        users: {
          read: true,
        },
        customizations: {
          read: true,
        },
        qatools: {
          read: true,
        },
      },
      flow_designer: {
        flows: {
          read: true,
          duplicate: true,
        },
      },
      viewer: {
        flows: {
          read: true,
        },
        reports: {
          read: true,
        },
      },
    },
  }),
});
